//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "MobileFooter",
  computed: {
    cssVars: function cssVars() {
      return {
        "--mf-spacing": "16px",
        "--mf-font-lg": "18px",
        "--mf-text-tertiary": "#9ca3af",
        "--mf-padding-top": "24px",
        "--mf-padding-bottom": "30px",
        "--mf-cta-height": "48px",
        "--mf-cta-font-size": "16px",
        "--mf-cta-radius": "24px",
        "--mf-cta-shadow": "0 4px 12px rgba(22, 104, 244, 0.3)",
        "--mf-arrow-ml": "6px",
        "--mf-info-mt": "20px",
        "--mf-line-font-size": "11px"
      };
    }
  },
  methods: {
    handleGoNation: function handleGoNation() {
      this.$emit("go-nation");
    }
  }
};